import React from 'react';

const ErrorIcon = ({className}) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <circle cx="12" cy="12" r="11" stroke="#E63740" strokeWidth="2" />
        <circle cx="12" cy="16" r="1" fill="#E63740" stroke="#E63740" />
        <path fill="#E63740" d="M13 13l.5-7c-.331-.667-.831-1-1.5-1s-1.169.333-1.5 1l.5 7h2z" />
      </g>
    </svg>
  );
};

export default ErrorIcon;
